import type { FC } from 'react'

import { InfoBox } from '@skytech/ui/InfoBox'
import { sanitizeAndInsertTargetBlank } from '@skytech/utils/html-sanitization'

import { useInjuryReportForm } from '@/forms/hooks'

import './RepairInstructions.styles.scss'

const RepairInstructions: FC = () => {
  const { data } = useInjuryReportForm()
  const { repairInstructions, status } = data

  if (status !== 'FOR_CONSIDERATION' || !repairInstructions) return null

  return (
    <section className="repair_instructions">
      <InfoBox emphasis="warning">
        <p
          dangerouslySetInnerHTML={{ __html: sanitizeAndInsertTargetBlank(repairInstructions) }}
          className="description"
        />
      </InfoBox>
    </section>
  )
}

export default RepairInstructions
